<template>
  <div class="form-control-static">
    <el-button v-for="(b, idx) in _actions"
               class="btn"
               :class="b.class"
               @click="click(b, idx)">
      {{isArray(b.label) ? i18n.fr.apply(i18n, b.label) : i18n.fr(b.label)}}
      <i v-if="processing === idx" class="ti-reload ti-spin"></i>
    </el-button>
  </div>
</template>

<style>
</style>

<script>
  import mixin from './mixin';
  import {isArray} from 'lodash';
  import {Button} from 'element-ui';
  import i18n from 'src/i18n/index';
  import {parseError} from 'src/utils';

  export default {
    name: 'f-button',
    mixins: [mixin],
    components: {
      [Button.name]: Button,
    },
    data() {
      return {
        processing: false,
      };
    },
    computed: {
      isArray: () => isArray,
      _actions() {
        if (typeof this.spec.actions === 'function') {
          return this.spec.actions.call(this, this.model, this.spec, this.readonly);
        } else if (isArray(this.spec.actions)) {
          return this.spec.actions;
        } else {
          return [];
        }
      },
    },
    methods: {
      reload() {
        // noop
      },
      click(b, idx) {
        let self = this;
        if (typeof b.action === 'function') {
          let p = b.action.call(self, self.model, self.spec, self.readonly);
          if (p && typeof p === 'object' && typeof p.then === 'function') {
            self.processing = idx;
            p.then(reload => {
              self.processing = false;
              if (reload) {
                (self.$rootForm || self.$parentForm || self).reload();
              }
            }, err => {
              self.processing = false;
              err = parseError(err);
              self.$notify({
                component: {template: i18n.f('alert.html.$err', {err})},
                icon: 'ti-alert',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger',
              });
            });
          }
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// f-button.vue?36c763ea